// extracted by mini-css-extract-plugin
module.exports = {"container":"UserDisplay_container__3OjlN"};